import { DiscordLink } from "@site/components/DiscordLink";
import { KofiButton } from "@site/components/KofiButton";
import { useLocale } from "@site/LocaleContext";
import {
  fetchChangelog,
  formatBuildLabel,
  getLatestRelease,
  getReleaseId,
} from "@shared/changelog";
import { markReleaseSeen } from "@site/config/releaseNotice";
import { useEffect, useState } from "react";
import styles from "@site/components/LandingFooter.module.css";

export function LandingFooter() {
  const { strings } = useLocale();
  const [buildLabel, setBuildLabel] = useState("");
  const [latestReleaseId, setLatestReleaseId] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      const data = await fetchChangelog();
      const latest = data ? getLatestRelease(data) : undefined;
      if (latest) {
        setBuildLabel(formatBuildLabel(latest.build));
        setLatestReleaseId(getReleaseId(latest));
      }
    })();
  }, []);

  const handleChangelogClick = (): void => {
    if (!latestReleaseId) {
      return;
    }
    markReleaseSeen(latestReleaseId);
  };

  return (
    <div className={styles.footer} data-testid="landing-footer">
      <div className={styles.discordWrap}>
        <DiscordLink />
      </div>
      <KofiButton className="kofi-landing" />
      <div className={styles.versionFooter} data-testid="version-footer">
        <span data-testid="version-label">{buildLabel}</span>
        <a
          className={`site-link ${styles.changelogLink}`}
          href="/changelog.html"
          data-testid="footer-changelog-link"
          onClick={handleChangelogClick}
        >
          {strings.landing.changelogLink}
        </a>
      </div>
    </div>
  );
}
